/* eslint-disable no-shadow */
/* eslint-disable sonarjs/no-redundant-boolean */
/* eslint-disable no-use-before-define */
/* eslint-disable sonarjs/no-duplicate-string */

import { showSpinner } from './helpers';

$(document).ready(() => {
  function initializeStyledIndexTable() {
    $('.styled-index-table').each(function () {
      const table = $(this);
      table.data('page', 1);
      modifyHeadersOfStyledIndexTable(table);
      table.wrap('<div></div>');
      addSearchFieldsForColumnsInStyledIndexTable(table);
      addSearchButtonToStyledIndexTable(table);
      addMoreButtonToStyledIndexTable(table);
      const lastRow = table.find('tbody tr').last();
      if (lastRow.length === 0 || lastRow.data('nextPage') === false) {
        $('.more-rows').addClass('hidden');
      }
    });
  }
  initializeStyledIndexTable();

  function modifyHeadersOfStyledIndexTable(table) {
    const headers = table.find('th');
    headers.each(function () {
      const modifiedHeader = `<div class='sortable-column'> \
            <span>${$(this).text()}</span>\
            <a class='sort-by asc desc'></a> \
          </div>`;
      $(this).html(modifiedHeader);
    });
  }

  function addMoreButtonToStyledIndexTable(table) {
    const addMoreButton = '<button class="nav-button more-rows">+ More</button>';
    table.after(addMoreButton);
  }

  function addSearchButtonToStyledIndexTable(table) {
    const searchButton = '<a class="nav-button search-in-rows">Search</a>';
    table.parent().prepend(searchButton);
  }

  function addSearchFieldsForColumnsInStyledIndexTable(table) {
    const thead = table.find('thead');
    const searchFields = thead.find('th').get().map((th) => {
      const fieldNameValue = $(th).data('fieldName');
      if (fieldNameValue) {
        return `<td data-field-name="${fieldNameValue}"><input type="text" class="search-in-column"></input></td>`;
      }

      return '<td></td>';
    }).join('');
    const searchFieldsRow = $('<tr class="search-fields hidden"></tr>').html(searchFields);
    thead.prepend(searchFieldsRow);
  }

  function intitializePaginationVariables(table) {
    let skipCount = 0;
    const takeCount = 20;
    let prevRowsCount = parseInt(table.data('prevRowsCount'), 10);
    if (!Number.isNaN(prevRowsCount)) {
      skipCount = prevRowsCount;
    } else {
      prevRowsCount = takeCount;
    }
    return { skip: skipCount, take: takeCount, rowsCount: prevRowsCount };
  }

  function showModifiedIndexTable(table, data, successCallback) {
    const url = table.data('indexUrl');
    $.ajax({
      url: `/${url}`,
      type: 'GET',
      dataType: 'html',
      data,
      beforeSend() { showSpinner(); },
      complete() { $('.spinner').hide(); },
      success(response) {
        successCallback(response);
        if (table.find('tr').last().data('nextPage') === false) {
          $('.more-rows').addClass('hidden');
        }
      },
    });
  }

  $(document).on('click', '.search-in-rows', function () {
    const table = $(this).siblings('.styled-index-table');
    table.find('.search-fields').toggle();
    const nextPage = table.find('tr').last().data('nextPage');
    if (nextPage) {
      if (table.find('.search-fields').is(':visible')) {
        $('.more-rows').addClass('hidden');
      } else {
        $('.more-rows').removeClass('hidden');
      }
    }
  });

  $(document).on('keyup', '.search-in-column', function () {
    const table = $(this).closest('.styled-index-table');
    const jsonHash = {};
    Array.from(document.querySelectorAll('.search-fields td')).forEach((input) => {
      const element = $(input);
      const fieldSearched = element.data('fieldName');
      const value = element.children().val();
      if (fieldSearched !== undefined && value !== undefined && value !== '') {
        jsonHash[fieldSearched] = value;
      }
    });
    const fieldsSearching = JSON.stringify(jsonHash);
    const data = { fields_searching: fieldsSearching, format: 'js' };
    const successCallback = (data) => {
      table.find('tbody').html(data);
      if (table.data('callback')) {
        window[table.data('callback')]();
      }
    };
    showModifiedIndexTable(table, data, successCallback);
  });

  $(document).on('click', '.styled-index-table th', function () {
    const table = $(this).closest('.styled-index-table');
    const sortBy = $(this).find('.sort-by');
    sortBy.closest('th').siblings().find('.sort-by').removeClass('asc desc')
      .addClass('asc desc');
    if (sortBy.hasClass('asc desc')) {
      sortBy.removeClass('desc');
    } else {
      sortBy.toggleClass('asc desc');
    }
    const fieldSort = $(this).data('fieldName');
    const order = sortBy.attr('class').split(' ').pop();
    const pageParams = intitializePaginationVariables(table);
    const allDisplayed = !$('.more-rows').is(':visible');
    const data = {
      field_sort: fieldSort, order, take: pageParams.rowsCount, format: 'js', all_displayed: allDisplayed,
    };
    const successCallback = function (data) {
      table.find('tbody').html(data);
      table.data('lastSort', fieldSort);
      table.data('lastSortOrder', order);
    };
    showModifiedIndexTable(table, data, successCallback);
  });

  $(document).on('click', '.more-rows', function () {
    const table = $(this).siblings('.styled-index-table');
    const pageParams = intitializePaginationVariables(table);
    const fieldSort = table.data('lastSort');
    const order = table.data('lastSortOrder');
    const data = { skip: pageParams.skip + 20, take: pageParams.take, format: 'js' };
    if (order) {
      data.field_sort = fieldSort;
      data.order = order;
    }
    const successCallback = function (data) {
      table.find('tbody').append(data);
      table.data('prevRowsCount', pageParams.skip + pageParams.take);
    };
    showModifiedIndexTable(table, data, successCallback);
  });

  $(document).on('click', '.search-in-column', function () {
    $(this).closest('td').siblings('td').find('.search-in-column')
      .each(function () {
        $(this).val('');
      });
  });
});
